import React, { useEffect, useState } from "react";

import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import Icon from "@mui/material/Icon";
import MDTypography from "components/MDTypography";
import Pagination from "@mui/material/Pagination";
import Loader from "Loader";
import { LanguageContext } from "App";
// import SessionsApi from 'Classes/API/Administration/SessionsApi';
import SearchStringOrIntReq from "../../Classes/Models/Requests/SearchStringOrIntReq";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import UserManagementApi from "../../Classes/API/Administration/UserManagementApi";
import SearchUsers from "./SearchUsers";
import CreateUserReq from "../../Classes/Models/Requests/Users/CreateUserReq";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import NoResult from "./NoResult";
import "./style.scss";
import translations from "layouts/Appointments/Feedback/translations";

const UsersTable = () => {
  const EmptySearchReq = new CreateUserReq();
  EmptySearchReq.pagingParams.pageSize = 10;
  const [SearchReq, setSearchReq] = useState(EmptySearchReq);
  const { translations } = useContext(LanguageContext);
  const TableColumns = [
    { Header: translations.userManagementPgTableElementsId, accessor: "Id", align: "left" },
    { Header: translations.userManagementPgTableElementsName, accessor: "Name", align: "left" },
    { Header: translations.userManagementPgTableElementsEmail, accessor: "Email", align: "left" },
    {
      Header: translations.userManagementPgTableElementsAddress,
      accessor: "Address",
      align: "center",
    },
    {
      Header: translations.userManagementPgTableElementsUserType,
      accessor: "UserType",
      align: "center",
    },
    {
      Header: translations.userManagementPgTableElementsIsActivated,
      accessor: "IsActivated",
      align: "left",
    },
    // {
    //   Header: translations.userManagementPgTableElementsIsAssessmentTherapist,
    //   accessor: "IsAssessmentTherapist",
    //   width: "200px",
    //   align: "left",
    // },
    {
      Header: translations.userManagementPgTableElementsIsSoftDeleted,
      accessor: "IsSoftDeleted",
      align: "left",
    },
    {
      Header: translations.userManagementPgTableElementsOptions,
      accessor: "Options",
      align: "center",
    },
    {
      Header: translations.userManagementPgTableElementsDelete,
      accessor: "Delete",
      align: "center",
    },
  ];

  const [TableDataRows, setTableDataRows] = useState([]);

  const [ResponseData, setResponseData] = useState({});

  const [IsLoaded, setIsLoaded] = useState(false);
  const [PaginationPages, setPaginationPages] = useState(0);
  const [Page, setPage] = useState(1);

  let navigate = useNavigate();

  const SoftDeleteUser = async (id) => {
    let req = new SearchStringOrIntReq();

    req.SearchInt = id;
    var res = await UserManagementApi.SoftDeleteUser(req);
    if (res.status == "Success") {
      setIsLoaded(false);
    }
  };

  const GetOptions = (user) => {
    navigate("/Users/Options", {
      state: {
        SearchUser: user,
      },
    });
  };

  const MakeTableRow = (user, index) => {
    return {
      Id: (
        <MDTypography
          className="table-data"
          component="a"
          variant="button"
          color="text"
          fontWeight="medium"
        >
          {user.id}
        </MDTypography>
      ),
      Name: (
        <MDTypography
          className="table-data"
          component="a"
          variant="button"
          color="text"
          fontWeight="medium"
        >
          {user.name}
        </MDTypography>
      ),

      Email: (
        <MDTypography
          className="table-data"
          component="a"
          variant="button"
          color="text"
          fontWeight="medium"
        >
          {user.email}
        </MDTypography>
      ),
      Address: (
        <MDTypography
          className="table-data"
          component="a"
          variant="button"
          color="text"
          fontWeight="large"
          width="10px"
        >
          {user.address}
        </MDTypography>
      ),
      UserType: (
        <MDTypography className="table-data" component="a" variant="button" color="dark">
          {user.userType}
        </MDTypography>
      ),

      IsActivated: (
        <>
          {user.isActivated ? (
            <span style={{ color: "green" }}>ACTIVE</span>
          ) : (
            <span style={{ color: "red" }}>INACTIVE</span>
          )}
        </>
      ),

      IsAssessmentTherapist: (
        <input
          id={"U.IsAssessmentTherapist" + user.id}
          type="checkbox"
          disabled="true"
          defaultChecked={user.isAssessmentTherapist}
        />
      ),

      IsSoftDeleted: (
        <input
          id={"U.IsSoftDeleted" + user.id}
          type="checkbox"
          disabled="true"
          defaultChecked={user.isSoftDeleted}
        />
      ),

      Options: (
        <MDTypography
          onClick={() => GetOptions(user)}
          component="a"
          variant="button"
          color="text"
          fontWeight="large"
          style={{ width: "35px", height: "35px", fontSize: "24px", marginTop: "20px" }}
        >
          <Icon style={{ fontSize: "40px" }}>settings</Icon>
        </MDTypography>
      ),
      Delete: (
        <MDButton
          onClick={() => SoftDeleteUser(user)}
          sx={{ backgroundColor: "#333333", "&:hover": { backgroundColor: "#4682B4" } }}
          color="dark"
        >
          <Icon sx={{ fontWeight: "bold" }}>delete</Icon>
        </MDButton>
      ),
    };
  };

  const GetTableData = async () => {
    SearchReq.pagingParams.pageNumber = Page;
    let tempReq = SearchReq;
    tempReq.Id = parseInt(SearchReq.Id, 10);
    var res = await UserManagementApi.SearchUsers(tempReq);

    if (res.status == "Success") {
      // let tempResponseData = [...res.data.list]
      setResponseData(res);
      setPaginationPages(res.data.totalPages);
      setIsLoaded(true);
    }
  };

  const RefreshTable = (resList) => {
    console.log("REfreshTAble", resList);
    if (resList == null) {
      setTableDataRows([]);
      return;
    }
    var rows = [];
    resList?.forEach((session, index) => {
      rows.push(MakeTableRow(session, index));
    });
    setTableDataRows(rows);
  };

  useEffect(async () => {
    if (!IsLoaded) {
      await GetTableData();
    }
  }, [IsLoaded]);

  useEffect(async () => {
    await GetTableData();
  }, [Page, SearchReq]);

  useEffect(() => {
    // if (ResponseData.length > 0) {
    RefreshTable(ResponseData?.data?.list);
    // }
  }, [ResponseData]);

  return (
    <>
      <SearchUsers
        setSearchReq={setSearchReq}
        SearchReq={SearchReq}
        GetTableData={GetTableData}
        className="mb-5"
      />
      {!IsLoaded && <Loader />}
      {IsLoaded && (
        <Card className="mt-5">
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            sx={{ backgroundColor: "#3560AD" }}
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
            textAlign="center"
          >
            <MDTypography variant="h6" color="white">
              {translations.userManagementPgTableHeaderManageUsersTable}
            </MDTypography>
          </MDBox>
          {ResponseData?.data?.list?.length > 0 ? (
            <MDBox pt={3}>
              <DataTable
                table={{ columns: TableColumns, rows: TableDataRows }}
                isSorted={false}
                entriesPerPage={false}
                showTotalEntries={false}
                noEndBorder
              />
            </MDBox>
          ) : (
            <div>
              <NoResult />
            </div>
          )}

          <div className="text-right mx-3 my-4">
            <Pagination
              count={PaginationPages}
              color="primary"
              onChange={(e, number) => setPage(number)}
              className="Pagination"
            />
          </div>
        </Card>
      )}
    </>
  );
};

export default UsersTable;
